import React, { useState, useEffect, useContext } from 'react';
import { AppContext } from '../../util/AppContext';
import PropType from 'prop-types';
import { getConfigValue } from '../../util/getConfigValue';
import { getProductMessageTypes } from '../../API/config';
import { useErrorBoundary } from "react-error-boundary";

ReportMessagesDropDown.propTypes = {
    isMenuVisible: PropType.bool,
    setIsMenuVisible: PropType.func,
    isEnabled: PropType.bool,
    menuContentRef: PropType.object,
    menuRef: PropType.object,
    setFilterState: PropType.func,
    filterState: PropType.object
}

function ReportMessagesDropDown(props) {
    const {
        isMenuVisible,
        setIsMenuVisible,
        isEnabled,
        menuContentRef,
        menuRef,
        setFilterState,
        filterState,
    } = props;

    const { showBoundary } = useErrorBoundary();
    const [messageCategoryOptions, setMessageCategoryOptions] = useState([]);
    const [appState] = useContext(AppContext);
    const [isLoading, setIsLoading] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedLabel, setSelectedLabel] = useState(getConfigValue(appState.config.UtilizationDashboard?.Filters?.MessageTypes.Label, appState)?.Value || "Select Message");
    const defaultOption = { label: getConfigValue(appState.config.UtilizationDashboard?.Filters?.MessageTypes?.DefaultSelected?.Label, appState)?.Value || "All Messages", value: getConfigValue(appState.config.UtilizationDashboard?.Filters?.MessageTypes?.DefaultSelected?.value, appState)?.Value || -1 };

    useEffect(() => {
        let label = defaultOption.label;
        if (selectedItem?.label != null && isEnabled) {
            label = selectedItem.label;
        }

        if (isLoading === null && isEnabled) {
            setIsLoading(true);
            getData();
        }

        setSelectedLabel(label);
    }, [isLoading, isEnabled]);

    useEffect(() => {
        getData();
    }, [filterState.selectedProductIds]); 

    useEffect(() => {
        if (isLoading !== null && isLoading) {
            setFilterState({ ...filterState, messageCategoryId: defaultOption.value, messageCategoryTitle: defaultOption.label });
            setSelectedLabel(defaultOption.label);
            setIsLoading(false);
        }

    }, [messageCategoryOptions, isEnabled]);


    const getData = async () => {
        const messageCategories = new Map();

        messageCategories.set(defaultOption.value, defaultOption);

        if(filterState.selectedProductIds) {
            await getProductMessageTypes(filterState.selectedProductIds)
            .then((responseJson) => {
                if(responseJson.length > 0) {
                    responseJson.map(function(item) { return item.messageTypes;}).flat()
                    .forEach((messageCategory) => {
                        messageCategories.set(messageCategory.messageTypeId, {
                            label: messageCategory.messageType,
                            value: messageCategory.messageTypeId
                        });
                    });
                }
                setMessageCategoryOptions(Array.from(messageCategories.values()));
            })
            .catch((err) => {
                showBoundary(err);
            })
            .finally(() => { });
        }
    }


    if (isEnabled && (isLoading === null || isLoading)) {
        return (<div className='p-5'>{getConfigValue(appState.config.Common?.Loading, appState)?.Value}</div>);
    }
    return (
        <div className="mb-4 my-lg-0">
            <button
                disabled={!isEnabled}
                ref={menuRef}
                onClick={() => setIsMenuVisible(isMenuVisible => !isMenuVisible)}
                aria-expanded={isMenuVisible ? "true" : "false"}
                className="border-0 px-0 bg-transparent text-start d-block"
                type="button"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside">
                <div
                    className={!isEnabled ? "p-3 opacity-50" : "p-3"}>
                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            <span className="type-20 type-bold me-2">{selectedLabel}</span>
                        </div>
                        <span className="fa-solid fa-chevron-down"></span>
                    </div>
                </div>
            </button>
            <div
                ref={menuContentRef}
                className="dropdown-rc-options"
                id="dropdown-rc-options">
                <div className={`dropdown-menu dropdown-menu-end ${isMenuVisible ? "show" : " "}`}>
                    {
                        messageCategoryOptions.map((item, index) => {
                            return (
                                <button
                                    key={index}
                                    value={item.value}
                                    label={item.label}
                                    className="border-0 px-0 bg-transparent text-start d-block w-100"
                                    onClick={(e) => { setFilterState({ ...filterState, messageCategoryId: item.value, messageCategoryTitle: item.label }); setIsMenuVisible(false); setSelectedLabel(item.label); setSelectedItem(item) }}
                                >
                                    <div className="p-2 px-5"
                                        onMouseEnter={(e) => e.currentTarget.classList.add("bg-light")}
                                        onMouseLeave={(e) => e.currentTarget.classList.remove("bg-light")}
                                    >
                                        <p className="my-0 color-grey-dark-2 type-18">{item.label}</p>
                                    </div>
                                </button>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    );
}

export default ReportMessagesDropDown;